export default __webpack_public_path__ + "static/media/Front-Sheyaaka-Production-House-6.58e85a67.jpg";